import { SellerApiOneC as SellerApiOneCComponent } from 'components/sellers/SellerApiOneC/SellerApiOneC'
import { useParams } from 'react-router-dom'

export const SellerApiOneC: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerApiOneCComponent type='seller' sellerId={id as string} />
}
